<template>
  <div>
    <px-view-header title="Alçadas de compra" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <px-alcadas-list v-else/>
  </div>
</template>

<script>
import AlcadasList from '@/modules/alcadas/components/AlcadasList.vue';

export default {
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Configurações' },
        { text: 'Alçadas de compra' },
      ],
    };
  },
  components: {
    pxAlcadasList: AlcadasList,
  },
};
</script>
